// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8v-3";
export var contentContainer = "_8v-0";
export var editorContainer = "_8v-1";
export var quillInputForm = "_8v-2";
export var zoneDivider = "_8v-4";